import { render, staticRenderFns } from "./PermissionNotAssigned.vue?vue&type=template&id=12a072ed&scoped=true&"
import script from "./PermissionNotAssigned.vue?vue&type=script&lang=js&"
export * from "./PermissionNotAssigned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a072ed",
  null
  
)

export default component.exports